// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-7d21dea7]:export {\n  menuBg: #b58643;\n  menuText: #e0e0e0;\n  menuActiveText: #ffe164;\n  menuActiveBg: #906a35;\n}\n\n/* Mixins */\n.edit-input[data-v-7d21dea7] {\n  padding-right: 100px;\n}\n.cancel-btn[data-v-7d21dea7] {\n  position: absolute;\n  right: 15px;\n  top: 10px;\n}\nh4[data-v-7d21dea7],\np[data-v-7d21dea7] {\n  margin: 0;\n}\n.noPaddingTopBottom[data-v-7d21dea7] {\n  padding-top: 0;\n  padding-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
